import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8b1c03d2")

_pushScopeId("data-v-8b1c03d2")
const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = { class: "p-input-icon-left p-mr-2" }
const _hoisted_3 = { class: "p-text-truncate p-text-nowrap" }
const _hoisted_4 = {
  key: 0,
  class: "pi pi-info-circle p-ml-1",
  style: {"vertical-align":"text-bottom"}
}
const _hoisted_5 = {
  key: 0,
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_6 = {
  key: 1,
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_7 = {
  key: 0,
  class: "p-d-flex p-jc-center",
  style: {"width":"100%"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_DataTable, {
      value: _ctx.files,
      responsiveLayout: "scroll",
      rowHover: true,
      ref: "listFiles"
    }, _createSlots({
      header: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", null, [
            _createVNode("span", _hoisted_2, [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.keyword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyword = $event)),
                placeholder: _ctx.$t('label.search'),
                class: "p-pl-1",
                onKeyup: _ctx.reload
              }, null, 8, ["modelValue", "placeholder", "onKeyup"])
            ])
          ]),
          (_ctx.canEdit())
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: _ctx.$matchMedia.desktop ? _ctx.$t('button.upload') : '',
                icon: !_ctx.loadingFiles ? 'pi pi-upload' : 'pi pi-spinner pi-spin',
                class: "p-button-primary p-ml-auto",
                onClick: _ctx.addFile,
                disabled: _ctx.loadingFiles
              }, null, 8, ["label", "icon", "onClick", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ]),
      empty: _withId(() => [
        (_ctx.keyword)
          ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("datasource.list-datasource.table.empty")), 1))
          : _createCommentVNode("", true)
      ]),
      default: _withId(() => [
        _createVNode(_component_Column, {
          field: "name",
          header: _ctx.$t('datasource.list-files.table.column.name'),
          style: {"max-width":"50rem"},
          class: "p-text-truncate p-text-nowrap",
          sortable: true
        }, {
          body: _withId((slotProps) => [
            _withDirectives(_createVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.getFileName(slotProps.data)), 1)
            ], 512), [
              [
                _directive_tooltip,
                _ctx.getFileName(slotProps.data),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('datasource.list-files.table.column.status'),
          field: "status"
        }, {
          body: _withId((slotProps) => [
            _createVNode("span", {
              class: 
              'p-p-0 status-badge status-' + slotProps.data.status.toLowerCase()
            
            }, [
              _createTextVNode(_toDisplayString(slotProps.data.status) + " ", 1),
              (slotProps.data.message)
                ? _withDirectives((_openBlock(), _createBlock("i", _hoisted_4, null, 512)), [
                    [_directive_tooltip, slotProps.data.message]
                  ])
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('datasource.list-files.table.column.size'),
          sortable: true,
          field: "size"
        }, {
          body: _withId((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.$humanFileSize(slotProps.data.size)), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('datasource.list-files.table.column.uploaded_date'),
          sortable: true,
          field: "updateDate"
        }, {
          body: _withId((slotProps) => [
            _withDirectives(_createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$moment(slotProps.data.createdDate).format("YYYY-MM-DD")), 1)
            ], 512), [
              [_directive_tooltip, _ctx.$moment(slotProps.data.createdDate).format('YYYY-MM-DD')]
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('datasource.list-files.table.column.uploaded_by')
        }, {
          body: _withId((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.getFullname(slotProps.data.createdBy)), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        (_ctx.canEdit())
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              exportable: false,
              header: _ctx.$t('datasource.list-files.table.column.action')
            }, {
              body: _withId((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-download",
                  class: "p-button-rounded p-button-secondary p-button-text p-mr-2",
                  disabled: !_ctx.isEnableDownload(slotProps.data.status),
                  onClick: ($event: any) => (_ctx.downloadFile(slotProps.data))
                }, null, 8, ["disabled", "onClick"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-rounded p-button-secondary p-button-text",
                  disabled: !_ctx.isEnableDelete(slotProps.data.status),
                  onClick: ($event: any) => (_ctx.confirmDeleteFile($event, slotProps.data))
                }, null, 8, ["disabled", "onClick"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.hasMoreFiles() || _ctx.loadingFiles)
        ? {
            name: "footer",
            fn: _withId(() => [
              (!_ctx.loadingFiles && _ctx.hasMoreFiles())
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode(_component_Button, {
                      label: _ctx.$t('button.more'),
                      class: "p-button-text",
                      onClick: _ctx.loadMoreFiles
                    }, null, 8, ["label", "onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loadingFiles)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode(_component_ProgressSpinner, {
                      class: "file-progress-spinner",
                      strokeWidth: "3",
                      animationDuration: ".5s",
                      style: {"width":"24px","height":"24px"}
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1032, ["value"])
  ]))
})